import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LookupInput } from '@components';

export const Lookup: React.FC = () => {
	const navigate = useNavigate();
	const navigateToProperty = () => {
		navigate('/property', { replace: true });
	};
	return (
		<div className="w-full  mx-auto  text-center pt-6">
			<h1 className="text-2xl font-bold-600 text-[24px]   mb-4">
				Property Lookup
			</h1>

			<div className="mx-auto  mt-16 w-full md:w-[47%]">
				<div className="mb-12 mx-5">
					<p className="block font-medium   mb-6">
						Enter an address to find information about a building:
					</p>
					<div className="flex justify-center w-full">
						<LookupInput navigaterFunction={navigateToProperty} />
					</div>
				</div>
				<div className="mb-6 mt-6 mx-5">
					<p className="block font-medium   mb-6">
						<span className="font-medium  ">
							You can also{' '}
							<span
								className="text-link"
								onClick={() => navigate('/district-dashboard')}
							>
								View data about a district or zip code
							</span>{' '}
							or{' '}
							<span className="text-link" onClick={() => navigate('/search')}>
								create a Custom Search
							</span>
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};
